import * as Api from "@api";
import { State } from "@store";
import { ActionType } from "../types";
import { IS_EMAIL } from "@constants";
import { ThunkAction } from "redux-thunk";
import { UserID, UserIDAction } from "../types/user_ids";

function getUserIDRequest(email: string): UserIDAction {
  return {
    type: ActionType.GET_USER_ID_REQUEST,
    email,
  };
}

function getUserIDSuccess(email: string, user_id: UserID): UserIDAction {
  return {
    type: ActionType.GET_USER_ID_SUCCESS,
    email,
    user_id,
  };
}

function getUserIDFailure(email: string, error: Error): UserIDAction {
  return {
    type: ActionType.GET_USER_ID_FAILURE,
    email,
    error,
  };
}

export function getUserID(
  email: string,
  force: boolean = false
): ThunkAction<void, State, unknown, UserIDAction> {
  return async (dispatch, getState) => {
    const { network, user_ids } = getState();

    if (
      email &&
      !force &&
      !user_ids[email] &&
      IS_EMAIL.test(email) &&
      !network.fetching.user_ids[email] &&
      typeof user_ids[email] !== "string"
    ) {
      dispatch(getUserIDRequest(email));
      try {
        const user_id = await Api.getUserID(email);

        dispatch(getUserIDSuccess(email, user_id));
      } catch (error) {
        dispatch(getUserIDFailure(email, error));
      }
    }
  };
}
